document.addEventListener('DOMContentLoaded', () => {
    initCameraComparisonToggle();
    initGroupToggles();
});

function initCameraComparisonToggle() {
    const btn   = document.getElementById('toggle-camera-comparison');
    const panel = document.getElementById('camera-comparison');

    if (!btn || !panel) return;

    btn.addEventListener('click', () => {
        const isExpanded = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', String(!isExpanded));
        panel.hidden = isExpanded;

        if (!isExpanded) {
            panel.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    });
}

function initGroupToggles() {
    const panel = document.getElementById('camera-comparison');

    if (!panel) return;

    panel.querySelectorAll('.camera-comparison__group-toggle').forEach(btn => {
        btn.addEventListener('click', () => {
            const groupId    = btn.dataset.group;
            const isExpanded = btn.getAttribute('aria-expanded') === 'true';

            btn.setAttribute('aria-expanded', String(!isExpanded));

            panel
                .querySelectorAll(`.camera-comparison__row[data-group="${groupId}"]`)
                .forEach(row => {
                    row.hidden = isExpanded;
                });
        });
    });
}
